module.exports = (date) => {
  // 日期处理 如：2017-06-22  ->  170622
  const time = date;
  return time.substring(2).replace(/-/g, '');
};

